import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
const styles = StyleSheet.create({
    oto: {
      padding:16,
    },
    title: {
      fontSize: 24,
      textAlign: 'center',
      fontFamily: 'Oswald'
    },
    author: {
      fontSize: 12,
      textAlign: 'center',
      marginBottom: 40,
    },
    subtitle: {
      fontSize: 18,
      margin: 12,
      fontFamily: 'Oswald'
    },
    text: {
        fontFamily: 'Lato',
        fontSize: 14,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color:'#000000',
    },
    image: {
      marginVertical: 15,
      marginHorizontal: 100,
    },
    header: {
      fontSize: 12,
      marginBottom: 20,
      textAlign: 'center',
      color: 'grey',
    },
    pageNumber: {
      position: 'absolute',
      fontSize: 12,
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: 'center',
      color: 'grey',
    },
  });

  const ContractDocument = () => (
    <Document>
    <Page  style={styles.oto}>
    <Text style={styles.text} >
    Al objeto de garantizar la confidencialidad del presente [Proyecto, colaboración entre las partes implicadas], se hace necesario la firma de un acuerdo que garantice unos niveles de confianza entre las partes. El documento se firmará una vez aceptado y firmado el (tipo:contrato, acuerdo,...] por ambas partes.

El contenido del acuerdo es el que figura a continuación. Contenido DE UNA PARTE: [nombre de la organización]y en su nombre y representación (con poder suficiente para ello) D/Dña. [nombre completo], en calidad de [cargo, administrador,
apoderado,...] DE OTRA PARTE: [nombre de la organización]. y en su nombre y representación (con poder suficiente para ello) D/Dña. [nombre completo], en calidad de [cargo, administrador, apoderado,...]

Reunidos en [lugar de la firma del contrato], a [día] de [Mes] de [Año]

EXPONEN
I – Que las partes, anteriormente citadas, están interesadas en el desarrollo del presente contrato, para lo cual, aceptaron celebrar el presente Acuerdo de Confidencialidad con el fin de establecer el procedimiento que regirá la custodia y no transmisión a terceros de la información distribuida entre las partes, así como los derechos, responsabilidades y
obligaciones inherentes en calidad de remitente, Propietario y «Destinatario» de la referida información.

II – Que las partes, en virtud de lo anteriormente expuesto, convinieron que el presente Acuerdo de Confidencialidad se rija por la normativa aplicable al efecto y, en especial por las siguientes.

CLÁUSULAS
PRIMERA - Definiciones
A los efectos del presente Acuerdo, los siguientes términos serán interpretados de acuerdo
con las definiciones anexas a los mismos. Entendiéndose por:

 - «Información propia»: tendrá tal consideración y a título meramente enunciativo y no limitativo, lo siguiente: descubrimientos, conceptos, ideas, conocimientos, técnicas, diseños,
dibujos, borradores, diagramas, textos, modelos, muestras, bases de datos de cualquier tipo, aplicaciones, programas, marcas, logotipos, así como cualquier información de tipo técnico, industrial, financiero, publicitario, de carácter personal o comercial de cualquiera de las partes, esté o no incluida en la solicitud de oferta presentada, independientemente de su formato de presentación o distribución, y aceptada por los «Destinatarios».

- «Fuente»: tendrá la consideración de tal, cualquiera de las partes cuando, dentro de los
términos del presente Acuerdo, sea ella la que suministre la Información Propia y/o
cualquiera de los implicados (accionistas, directores, empleados, …) de la empresa o la
organización.

- «Destinatarios»: tendrán la consideración de tales cualquiera de las partes cuando,
dentro de los términos del presente Acuerdo, sea ellos quienes reciban la Información Propia
de la otra parte.

    </Text>
    <Text style={styles.header} >
            ~ Created with react-pdf ~
    </Text>
    <Text style={styles.header} >
            ~ Created with react-pdf ~
    </Text>
    <Text style={styles.header} >
            ~ Created with react-pdf ~
    </Text>
    
        
        
    </Page>
  </Document>
  );

export default  ContractDocument;